module.exports = __webpack_public_path__ + "img/Wp_2060.0eeeb22d.png";